// extracted by mini-css-extract-plugin
module.exports = {"root":"support-button_root__3NRLq","icon":"support-button_icon__vQiIl"};